"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = require("styled-components");

var _themeContants = require("../../constants/themeContants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

// TODO: Rename
var ThemeComponent =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ThemeComponent, _React$Component);

  function ThemeComponent() {
    _classCallCheck(this, ThemeComponent);

    return _possibleConstructorReturn(this, _getPrototypeOf(ThemeComponent).apply(this, arguments));
  }

  _createClass(ThemeComponent, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          theme = _this$props.theme,
          tagName = _this$props.tagName,
          fallback = _this$props.fallback,
          children = _this$props.children,
          _this$props$variant = _this$props.variant,
          variant = _this$props$variant === void 0 ? _themeContants.VARIANT_DEFAULT : _this$props$variant,
          props = _objectWithoutProperties(_this$props, ["theme", "tagName", "fallback", "children", "variant"]);

      var name = tagName.name ? tagName.name : tagName;

      if (!variant) {
        console.warn("Variant must be specified", name);
        return null;
      }

      var Component = !theme || !name || !theme.hasOwnProperty(name) ? fallback : theme[name];

      if (!Component) {
        console.warn("Tagname is not present in theme", name, variant, theme);
        return null;
      }

      var SubComponent = Component.hasOwnProperty(variant) ? Component[variant] : _typeof(Component) === "object" ? fallback : Component;

      if (!SubComponent) {
        console.warn("Could not find component nor subcomponent in theme.", name, variant, fallback, theme);
        return null;
      }

      return _react["default"].createElement(SubComponent, props, children);
    }
  }]);

  return ThemeComponent;
}(_react["default"].Component);

var _default = (0, _styledComponents.withTheme)(ThemeComponent);

exports["default"] = _default;